import { all, fork } from 'redux-saga/effects';
import { tracked } from 'shared/utils/sagaWrappers';
import { ACTIVATE, DEACTIVATE } from './actions';
import submitSaga from './components/SubmitSection/components/Submit/sagas';

export default tracked(
  function* () {
    yield all([fork(submitSaga)]);
  },
  ACTIVATE,
  DEACTIVATE
);
